import { useTranslation } from 'react-i18next';
import { Modal } from '../UI';
import { Button } from '../UI/base/Button';
import styles from './ErrorDialog.module.css';

interface ErrorDialogProps {
  title?: string;
  message: string;
  onClose: () => void;
}

export const ErrorDialog = ({ title, message, onClose }: ErrorDialogProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={title ?? t('error-dialog-title')}
      onClose={onClose}
      width={480}
      footer={
        <Button type="primary" onClick={onClose}>
          {t('error-dialog-close')}
        </Button>
      }
    >
      <p className={styles.modalMessage}>{message}</p>
    </Modal>
  );
};
